var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dialog-mask", attrs: { role: "presentation" } },
    [
      _c(
        "div",
        {
          staticClass: "dialog-content",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            "aria-describedby": _vm.descriptionId,
          },
        },
        [
          _c("header", { staticClass: "dialog-header" }, [
            _c(
              "h2",
              { staticClass: "dialog-title", attrs: { id: _vm.titleId } },
              [
                _vm._v(
                  _vm._s(_vm.$t("desktopBetaPage.windowsInstallGuide.title"))
                ),
              ]
            ),
          ]),
          _c(
            "p",
            {
              staticClass: "dialog-description",
              attrs: { id: _vm.descriptionId },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("desktopBetaPage.windowsInstallGuide.description")
                  ) +
                  " "
              ),
            ]
          ),
          _c("div", { staticClass: "dialog-image-wrap" }, [
            _c("img", {
              staticClass: "dialog-image",
              attrs: {
                src: require("@/assets/img/desktop-beta/windows-install.webp"),
                alt: String(
                  _vm.$t("desktopBetaPage.windowsInstallGuide.imageAlt")
                ),
              },
            }),
          ]),
          _c(
            "div",
            { staticClass: "dialog-actions" },
            [
              _c(
                "button-default",
                { staticClass: "confirm-button", on: { click: _vm.close } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("desktopBetaPage.windowsInstallGuide.confirm")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }